// services/emailAccounts.ts
import { AuthFetch } from "../hooks/useApi";
import {
  EmailAccountStatus,
  EmailAccountConnectResponse,
  EmailAccountDisconnectResponse,
} from "../types/emailAccount.types";

export const emailAccountService = {

  getStatus: (
    apiFetch: AuthFetch,
    doctorEmail: string,
  ): Promise<EmailAccountStatus> =>
    apiFetch<EmailAccountStatus>(`/email-accounts/status?doctor_email=${encodeURIComponent(doctorEmail)}`, {
      method: "GET",
    }),

  getGoogleConnectUrl: (
    apiFetch: AuthFetch,
    doctorEmail: string,
    returnTo: string,
  ): Promise<EmailAccountConnectResponse> =>
    apiFetch<EmailAccountConnectResponse>(
      `/email-accounts/google/connect?doctor_email=${encodeURIComponent(doctorEmail)}&return_to=${encodeURIComponent(returnTo)}`,
      { method: "GET" },
    ),

  disconnectGoogle: (
    apiFetch: AuthFetch,
    doctorEmail: string,
  ): Promise<EmailAccountDisconnectResponse> =>
    apiFetch<EmailAccountDisconnectResponse>(`/email-accounts/google?doctor_email=${encodeURIComponent(doctorEmail)}`, {
      method: "DELETE",
    }),
};
